import { ActionDataWidgets } from '@app/page/src/components/widgets/types'
import {
  CashApp,
  FacebookCircle,
  Instagram,
  Link,
  LinkedIn,
  MaskType,
  Snapchat,
  Spotify,
  TikTok,
  Twitter,
  Venmo,
  YouTube
} from '@dtx-company/shared-components/src'
import { ContactCollectionForm } from '@app/page/src/components/widgets/ContactCollectionForm/types'
import { MailFilled } from '@dtx-company/shared-components/src/foundation/Icons/Everyday/MailFilled'
import { PDF } from '@dtx-company/shared-components/src/foundation/Icons/Flowpage/Widgets/PDF/index'
import { PhoneFilled } from '@dtx-company/shared-components/src/foundation/Icons/Everyday/PhoneFilled'
import { SMSFilled } from '@dtx-company/shared-components/src/foundation/Icons/Everyday/SMSFilled'
import { SocialFormFields } from './SocialForm.types'

export interface SocialFormInputType {
  label: string
  prefix: string
  startAdornment?: React.MemoExoticComponent<(props: React.SVGProps<SVGSVGElement>) => JSX.Element>
  inputAdornmentText: string
  placeholder: string
  type?: string
  widgetType: ActionDataWidgets
}

type SocialFormInputsType = { [key in SocialFormFields]: SocialFormInputType }

export const SOCIAL_FORM_INPUTS: SocialFormInputsType = {
  [SocialFormFields.INSTAGRAM]: {
    label: 'Instagram',
    prefix: 'https://www.instagram.com/',
    startAdornment: Instagram,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.TIKTOK]: {
    label: 'Tiktok',
    prefix: 'https://www.tiktok.com/@',
    startAdornment: TikTok,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.VENMO]: {
    label: 'Venmo',
    prefix: 'https://www.venmo.com/',
    startAdornment: Venmo,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.CASHAPP]: {
    label: 'Cash App',
    prefix: 'https://cash.app/',
    startAdornment: CashApp,
    inputAdornmentText: '$',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.SNAPCHAT]: {
    label: 'Snapchat',
    prefix: 'https://www.snapchat.com/add/',
    startAdornment: Snapchat,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.LINK]: {
    label: 'Website',
    prefix: '',
    startAdornment: Link,
    inputAdornmentText: '',
    placeholder: 'www.website.com',
    widgetType: 'socialLink'
  },
  [SocialFormFields.TWITTER]: {
    label: 'Twitter',
    prefix: 'https://www.twitter.com/',
    startAdornment: Twitter,
    inputAdornmentText: '@',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.LINKEDIN]: {
    label: 'Linkedin',
    prefix: 'https://www.linkedin.com/in/',
    startAdornment: LinkedIn,
    inputAdornmentText: 'linkedin.com/in/',
    placeholder: 'yourname',
    widgetType: 'socialLink'
  },
  [SocialFormFields.YOUTUBE]: {
    label: 'YouTube',
    prefix: 'https://',
    startAdornment: YouTube,
    inputAdornmentText: '',
    placeholder: 'youtube.com/watch',
    widgetType: 'socialLink'
  },
  [SocialFormFields.FACEBOOK]: {
    label: 'Facebook',
    prefix: 'https://',
    startAdornment: FacebookCircle,
    inputAdornmentText: '',
    placeholder: 'facebook.com/',
    widgetType: 'socialLink'
  },
  [SocialFormFields.SPOTIFY]: {
    label: 'Spotify',
    prefix: 'https://',
    startAdornment: Spotify,
    inputAdornmentText: '',
    placeholder: 'open.spotify.com/track',
    widgetType: 'socialLink'
  },
  [SocialFormFields.BIGIMAGE]: {
    label: 'Embedded Image',
    prefix: '',
    startAdornment: undefined,
    inputAdornmentText: '',
    placeholder: 'file size limit: 10mb',
    type: 'file',
    widgetType: 'bigImage'
  },
  [SocialFormFields.PDF]: {
    label: 'File',
    prefix: '',
    startAdornment: PDF,
    inputAdornmentText: '',
    placeholder: 'Upload PDF',
    type: 'file',
    widgetType: 'pdf'
  },
  [SocialFormFields.EMAIL]: {
    label: 'Email',
    prefix: '',
    startAdornment: MailFilled,
    inputAdornmentText: '',
    placeholder: 'you@email.com',
    type: 'email',
    widgetType: 'contactInfo'
  },
  [SocialFormFields.SMS]: {
    label: 'SMS',
    prefix: '',
    startAdornment: SMSFilled,
    inputAdornmentText: '',
    placeholder: '555-555-5555',
    type: 'tel',
    widgetType: 'contactInfo'
  },
  [SocialFormFields.CALL]: {
    label: 'Call',
    prefix: '',
    startAdornment: PhoneFilled,
    inputAdornmentText: '',
    placeholder: '555-555-5555',
    type: 'tel',
    widgetType: 'contactInfo'
  }
}

//update getSocialsLandingPageDestination if new inputs are added.
export const WEBSITE_AND_SOCIAL_FORM_INPUT_ENTRIES = Object.entries(SOCIAL_FORM_INPUTS) as [
  SocialFormFields,
  SocialFormInputType
][]

export const PDFTitle = {
  COLLEGE: 'Resume',
  DEFAULT: 'Click Here!'
}

export const VARIANT_2_EXCLUSIVE = [
  SocialFormFields.EMAIL,
  SocialFormFields.SMS,
  SocialFormFields.CALL
]

export const NON_COMBINED_FUNNEL_CONTACT_WIDGETS = [SocialFormFields.EMAIL, SocialFormFields.CALL]

export const FLOWTAG_CONTACT_COLLECTION_DATA: ContactCollectionForm = {
  customFieldLabel: '',
  customFieldLabel2: '',
  customTerms: { enabled: false },
  description: '',
  displayType: 'default',
  fields: {
    address: false,
    age: false,
    custom: false,
    custom2: false,
    displayName: true,
    email: true,
    gender: false,
    phone: true
  },
  filledOutFormRequirement: false,
  googleSheets: { enabled: false },
  hubspot: { enabled: false, apiKey: '' },
  klaviyo: { enabled: false },
  mailChimp: { enabled: false, url: undefined },
  required: {
    address: false,
    age: false,
    custom: false,
    custom2: false,
    displayName: true,
    email: true,
    gender: false,
    phone: false
  },
  salesforce: { enabled: false, apiKey: '' },
  successMessage: { enabled: false, header: undefined, body: undefined },
  thumbNailImgUrl: '',
  title: 'Connect with me',
  widgetDisplayType: MaskType.NO_IMAGE,
  zapier: { enabled: false }
}
